export enum FinalReportRecallEnum {
  THREE_DAYS  = '00000232-1000-0000-0000-000000000002',
  ONE_WEEK    = '00000232-1000-0000-0000-000000000003',
  TWO_WEEKS   = '00000232-1000-0000-0000-000000000004',
  THREE_WEEKS = '00000232-1000-0000-0000-000000000005',
  SIX_WEEKS   = '00000232-1000-0000-0000-000000000006',
  ONE_MONTH   = '00000232-1000-0000-0000-000000000007',
  TWO_MONTHS  = '00000232-1000-0000-0000-000000000008',
  THREE_MONTHS = '00000232-1000-0000-0000-000000000009',
  SIX_MONTHS  = '00000232-1000-0000-0000-000000000010',
  ONE_YEAR  = '00000232-1000-0000-0000-000000000011',
  TWO_YEARS  = '00000232-1000-0000-0000-000000000012',
  THREE_YEARS  = '00000232-1000-0000-0000-000000000013',
  FOUR_YEARS  = '00000232-1000-0000-0000-000000000014',
  FIVE_YEARS  = '00000232-1000-0000-0000-000000000015',
  SIX_YEARS  = '00000232-1000-0000-0000-000000000016',
  SEVEN_YEARS  = '00000232-1000-0000-0000-000000000017',
  EIGHT_YEARS  = '00000232-1000-0000-0000-000000000018',
  NINE_YEARS  = '00000232-1000-0000-0000-000000000019',
  TEN_YEARS  = '00000232-1000-0000-0000-000000000020',
  ELEVEN_YEARS  = '00000232-1000-0000-0000-000000000021',
  TWELVE_YEARS  = '00000232-1000-0000-0000-000000000022',
  THIRTEEN_YEARS  = '00000232-1000-0000-0000-000000000023',
  FOURTEEN_YEARS  = '00000232-1000-0000-0000-000000000024',
  FIFTEEN_YEARS  = '00000232-1000-0000-0000-000000000025',
}
